import { render, staticRenderFns } from "./AgmPrivacy.vue?vue&type=template&id=77155662&scoped=true&"
var script = {}
import style0 from "./AgmPrivacy.vue?vue&type=style&index=0&id=77155662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77155662",
  null
  
)

export default component.exports